module.exports = __webpack_public_path__ + "static/krystian-biela-848c5e8f32251c2e6d88a74581cc8bbd.jpg";